import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
   providedIn: 'root'
})

export class SeoService {
   constructor(@Inject(DOCUMENT) private doc, private titleService: Title, private meta: Meta) { }

   // ------------ Set Page Title ------------
   defaultTitle() {
      this.titleService.setTitle('Free Online Grammar and Spell Checker | Grammarin.com');
   }

   setTitle(name) {
      this.titleService.setTitle(name + ' | GrammarIn.com');
   }
   plag_checker(){
      this.titleService.setTitle('Plagiarism Checker | Detect Copied Content With Percentage')
   }
   grammar_checker(){
      this.titleService.setTitle('Free Grammar Checker - GrammarIn AI')
   }
  
} 